(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/map-of-winners/assets/javascripts/collections/bigwins.js') >= 0) return;  svs.modules.push('/modules/map-of-winners/assets/javascripts/collections/bigwins.js');
"use strict";

(function (Backbone, _, svs) {
  'use strict';

  svs.map_of_winners.collections.BigWins = Backbone.Collection.extend({
    model: svs.map_of_winners.models.BigWin,
    comparator(a, b) {
      if (a.get('gameType') !== b.get('gameType')) {
        return a.get('gameType') - b.get('gameType');
      }
      if (a.get('city') !== b.get('city')) {
        return a.get('city').localeCompare(b.get('city'), 'sv', {
          sensitivity: 'base'
        });
      }
      if (a.get('retailer') !== b.get('retailer')) {
        return a.get('retailer').localeCompare(b.get('retailer'), 'sv', {
          sensitivity: 'base'
        });
      }

      return a.cid.localeCompare(b.cid);
    },
    initialize(models, options) {
      this.immutable = Boolean(options.immutable);
    },
    cloneCollection(collection) {
      if (collection && collection.immutable) {
        collection = collection.models;
      }
      return collection instanceof Backbone.Collection ? collection : new svs.map_of_winners.collections.BigWins(collection || this.models, {
        model: this.model,
        comparator: this.comparator,
        immutable: false
      });
    },
    mergeByKeyValue(compareKeys, collection, setAllAttributes) {
      const cloned = this.cloneCollection(collection),
        tmpClone = [];
      while (cloned.length) {
        let compareModel = cloned.pop();
        const compareObject = {};
        if (!compareKeys || !compareKeys.length) {
          const attributes = Object.getOwnPropertyNames(compareModel.attributes);
          compareKeys = [];
          setAllAttributes = true;
          for (let i = 0; i < attributes.length; i++) {
            if (compareModel.get(attributes[i]) !== undefined && typeof compareModel.get(attributes[i]) !== 'object') {
              compareKeys.push(attributes[i]);
            }
          }
        }
        for (let i = 0; i < compareKeys.length; i++) {
          compareObject[compareKeys[i]] = compareModel.get(compareKeys[i]);
        }
        const duplicatedModels = compareObject && cloned.where(compareObject);
        compareModel = new Backbone.Model(setAllAttributes ? compareModel.attributes : compareObject);
        if (duplicatedModels && duplicatedModels.length) {
          compareModel.set('numberOfClones', duplicatedModels.length + 1);
          cloned.remove(duplicatedModels);
        }
        tmpClone.push(compareModel);
      }
      cloned.reset(tmpClone);
      return cloned;
    },
    filterByAttributes(filterAttrs, mergeKeys, collection, setAllAttributes) {
      let filtered = this.cloneCollection(collection);
      if (typeof filterAttrs === 'object') {
        filtered.reset(filtered.where(filterAttrs));
        if (filtered.length && mergeKeys) {
          filtered = this.mergeByKeyValue(mergeKeys, filtered, setAllAttributes);
        }
      }
      return filtered;
    },
    sortMapCluster(onlyOnlineClusters) {
      const clusters = this.cloneCollection();
      this.setClusters(clusters, 'onlineCluster', onlyOnlineClusters ? 5 : 2, true);
      if (!onlyOnlineClusters) {
        this.setClusters(clusters, 'clustered', 4);
      }
      return clusters;
    },
    setClusters(collection, clusterType, clusterViewSize, hasPosition) {
      const tmpClusters = [];
      while (collection.length) {
        const compareModel = collection.pop(),
          compareX = parseFloat(compareModel.get('position').horizontalPos.toPrecision(2)),
          compareY = parseFloat(compareModel.get('position').verticalPos.toPrecision(2));
        let rangeX = {
            min: compareX,
            max: compareX,
            avg: compareX
          },
          rangeY = {
            min: compareY,
            max: compareY,
            avg: compareY
          };
        const clusters = _.filter(collection.models, model => {
          const modelX = parseFloat(model.get('position').horizontalPos.toPrecision(2)),
            modelY = parseFloat(model.get('position').verticalPos.toPrecision(2)),
            isClustered = Math.abs(modelX - rangeX.avg) < clusterViewSize && Math.abs(modelY - rangeY.avg) < clusterViewSize;
          if (isClustered) {
            rangeX = this.setAverageXY(rangeX.min, rangeX.max, modelX);
            rangeY = this.setAverageXY(rangeY.min, rangeY.max, modelY);
            model.set(clusterType, true);
          }
          return isClustered;
        });
        if (clusters && clusters.length) {
          collection.remove(clusters);
          compareModel.set(clusterType, true);
          clusters.push(compareModel);
          tmpClusters.push(new Backbone.Model({
            position: hasPosition && compareModel.get('position'),
            cluster: clusters,
            [clusterType]: true
          }));
        } else {
          tmpClusters.push(compareModel);
        }
      }
      collection.reset(tmpClusters);
    },
    setAverageXY(min, max, compare) {
      min = Math.min(min, compare);
      max = Math.max(max, compare);
      return {
        min,
        max,
        avg: (min + max) / 2
      };
    }
  });
})(Backbone, _, svs);

 })(window);